import React from "react";

type MetadataFieldProps = {
  name: string;
  value: string;
  dataLoc: string;
};

export const MetadataField: React.FC<MetadataFieldProps> = ({
  name,
  value,
  dataLoc,
}) => {
  return (
    <div className="flex gap-1" data-loc={dataLoc}>
      <div className="w-1/4 min-w-[100px] font-inter-normal-12px text-gray-600">
        {name}
      </div>
      <div className="w-3/4 font-inter-normal-13px text-gray-800">{value}</div>
    </div>
  );
};
